(function () {
	'use strict';

    angular.module("imApp").factory("dispatchPlanningOrderLinesService", ['$ihttp', function ($ihttp) {
		let service = {
            listOrderLines: function (parms) {
                return $ihttp.post({
                    method: 1637,
                    parameters: parms || {}
                });
            }
		};

		return service;
	}]);
})();
